import { Score } from '@zxcvbn-ts/core/dist/types'

import { Progress } from '@/components/ui/progress'

const getPasswordBarColorScheme = (score: Score | undefined) => {
  if (!score) return 'red'

  if (score === 1) return 'red'
  if (score === 2) return 'orange'
  if (score === 3) return 'yellow'

  return 'green'
}

export const PasswordStrengthBar = ({
  score,
}: {
  score: Score | undefined
}) => {
  const colorScheme = getPasswordBarColorScheme(score || 1)

  return (
    <Progress
      color={colorScheme}
      className="mt-2 rounded-md"
      value={score ? score * 25 : 0}
    />
  )
}
